<!-- 单品价格详情 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <div class="info-list-title title-search">
          <span class="title-search-name">牛油果</span>
          <!--<a href="javascript(0)" class="title-search-button">更多品种</a>-->
        </div>
        <div class="info-list-content">
            <ul class="list-tab-search-ul" v-if="tabList.length>0">
              <li v-for="(tab, index) in tabList" v-bind:class="['list-tab-search-li',index==defaultTab ?'li-active' : '']" v-on:click="selectedAct(index)">{{tab.title}}</li>
            </ul>
            <div class="list-tab-search-detail">
                <!--<table class="search-detail-table" cellspacing="0px" border="0px">
                  <tr>
                    <td class="search-title">仓库位置:</td>
                    <td>
                      <a class="search-detail">不限</a>
                      <a class="search-detail">呈贡区</a>
                      <a class="search-detail">官渡区</a>
                      <a class="search-detail">五华区</a>
                      <a class="search-detail">嵩明区</a>
                      <a class="search-detail">晋宁区</a>
                      <a class="search-detail">盘龙区</a>
                      <a class="search-detail">富民县</a>
                      <a class="search-detail">西山区</a>
                      <a class="search-detail">安宁市</a>
                    </td>
                  </tr>
                  <tr>
                    <td class="search-title">仓库类型:</td>
                    <td>
                      <a class="search-detail">不限</a>
                      <a class="search-detail">暖库</a>
                      <a class="search-detail">冷库</a>
                      <a class="search-detail">恒温库</a>
                      <a class="search-detail">常温库</a>
                    </td>
                  </tr>
                  <tr>
                    <td class="search-title">仓库类型:</td>
                    <td>
                      <a class="search-detail">不限</a>
                      <a class="search-detail">暖库</a>
                      <a class="search-detail">冷库</a>
                      <a class="search-detail">恒温库</a>
                      <a class="search-detail">常温库</a>
                    </td>
                  </tr>
                </table>-->
            </div>
            <div class="list-content-detail">
                <div class="detail-label">
                    <table class="detail-label-table" cellspacing="0px" border="0px">
                      <tr>
                        <td class="product-title" colspan="5">牛油果--{{detailInfo.dependency}}</td>
                      </tr>
                      <tr>
                        <td class="title">今日产地价格</td>
                        <td class="title">近昨日</td>
                        <td class="title">近上周</td>
                        <td class="title">较上月</td>
                        <td class="title">近去年</td>
                      </tr>
                      <tr>
                        <td class="value">{{detailInfo.price}}/{{detailInfo.unit}}</td>
                        <td class="value">{{detailInfo.daily_change}}</td>
                        <td class="value">{{detailInfo.weekly_change}}</td>
                        <td class="value">{{detailInfo.monthly_change}}</td>
                        <td class="value">{{detailInfo.yearly_change}}</td>
                      </tr>
                      <tr>
                        <td  class="data" colspan="5">{{detailInfo.create_time}}</td>
                      </tr>
                    </table>
                </div>
                <div class="detail-chart">
                  <ul class="list-tab-chart-ul" v-if="chartTabList.length>0">
                    <li v-for="(tab, index) in chartTabList" v-bind:class="['list-tab-chart-li',index==defaultChartTab ?'li-chart-active' : '']" v-on:click="selectedChartAct(index)">{{tab.title}}</li>
                  </ul>
                  <chart-line-01 ref="chart_001" chartId="chart_001" title="价格走势" :legendShow=false chartWidth="100%" chartHeight="124px" v-on:queryPage="detail_Req"/>
                </div>
            </div>
            <div class="list-content-detail">
                <div class="detail-label"><span class="product-location">{{detailInfo.province}}-{{detailInfo.city}}-{{detailInfo.district}}</span><span class="product-remark"></span></div>
                <div class="detail-table">
                  <table class="detail-price-table" cellspacing="0px" border="0px">
                    <tr>
                      <td>年/月</td>
                      <td>1月份</td>
                      <td>2月份</td>
                      <td>3月份</td>
                      <td>4月份</td>
                      <td>5月份</td>
                      <td>6月份</td>
                      <td>7月份</td>
                      <td>8月份</td>
                      <td>9月份</td>
                      <td>10月份</td>
                      <td>11月份</td>
                      <td>12月份</td>
                    </tr>
                    <tr v-for="(data, index) in tableData">
                      <td>{{data.year}}</td>
                      <td>{{data['1']}}</td>
                      <td>{{data['2']}}</td>
                      <td>{{data['3']}}</td>
                      <td>{{data['4']}}</td>
                      <td>{{data['5']}}</td>
                      <td>{{data['6']}}</td>
                      <td>{{data['7']}}</td>
                      <td>{{data['8']}}</td>
                      <td>{{data['9']}}</td>
                      <td>{{data['10']}}</td>
                      <td>{{data['11']}}</td>
                      <td>{{data['12']}}</td>
                    </tr>
                  </table>
                </div>
            </div>
          </div>
      </div>
      <div class="content-col col-per-30">
        <infoList-04 title="精选行情" label="INFORMARION" titleLength="20" count="8"/>
        <infoList-04 title="每周果情" label="INFORMARION" titleLength="20" count="8"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import JghqInfo from '../module/JghqInfo'
import InfoList04 from '../block/InfoList04'

import Line01 from '../chart/Line01'
export default {
  name: 'Sghq01DetailA',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList-04': InfoList04,
    'chart-line-01':Line01,
  },
  data() {
    return {
      detailId:'0',
      defaultTab:0,
      defaultChartTab:0,
      msg: '',
      infoBlock:JghqInfo,
      tabList:[{title:"产地价格"},{title:"市场价格"}],
      chartTabList:[{title:"日价格"},{title:"月价格"}],
      detailInfo:{},
      tableData:[],
      chartData:{axis:[],data:[]},
    }
  },
  methods:{
    selectedAct:function(index){
      this.defaultTab=index;
      this.$emit("clickTab",index);
    },
    selectedChartAct:function(index){
      this.defaultChartTab=index;
      this.$emit("clickTab",index);
    },
    detail_Req(){
      let that=this;
      let params={objectId:that.detailId,type:1};
      that.$dataApi.priceDetail(params).then(res =>{
          that.msg=res.msg;
          that.detailInfo=res.data.detail;
          that.tableData=res.data.table_data;
          that.chartData=res.data.e_chart;
          that.$refs.chart_001.drawLine(that.chartData.axis,[that.chartData.data]);
          console.log('结束请求Vue-axios：'+JSON.stringify(that.chartData))
        });
    },
  },
  created:function(){
    let that=this;
    that.detailId=that.$route.params.id;
    //console.log("详情页面接收属性：idTest1="+that.idTest1+"--idTest2="+that.idTest2);
    //console.log("详情页面接收参数：params="+JSON.stringify(that.$route.params));
    console.log("详情页面接收查询：params="+that.detailId);
    //that.detail_Req(detailId);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}


ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}

.title-search{
  //background:red;
  height:30px;
  border:0px;
}
.title-search-name{
  display: block;
  float:left;
  padding:0px;
  margin-left:10px;
  border-bottom:0px;
  line-height:30px;
}

.title-search-button {
  display: block;
  float:left;
  width: 100px;
  height: 30px;
  padding:0px;
  margin-left:20px;
  text-decoration: none;
  background: #eeeeee;
  border:1px solid #515151;
  font-size: 12px;
  color:#515151;
  text-align: center;
  line-height: 30px;
  letter-spacing:2px;
}

.list-tab-search-ul {
  display:flex;
  justify-content:flex-start;
  margin: 5px 0px 0px 0px;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px;
  background:#eee;
}

.list-tab-search-li {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  //font-weight: 300;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-tab-search-detail{
  position:relative;
  width:100%;
  height:100%;
  background:#fff;
  border:1px solid #eee;
  margin-bottom:5px;
}

.search-detail-table{
  width:100%;
  text-align:left;
  border-color:#eee;
  border-width:0px;
  border-bottom:0px;
}

.search-detail-table td{
  height:40px;
  padding-left:10px;
  border-bottom:1px solid #eee;
}

.search-detail{
  margin-right:10px;
}

.search-detail:hover{
  color:var(--color6);
  cursor: pointer;
}

.list-tab-search-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.li-active{
  color: #ffffff;
  background: #598118;
  background: -moz-linear-gradient(left,  #598118 50%, #BE550F 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%,#BE550F), color-stop(100%,#BE550F));
  background: -webkit-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -o-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -ms-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: linear-gradient(to right,  #598118 f0%,#BE550F 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#598118', endColorstr='#BE550F',GradientType=0 );
}

.list-content-detail{
  position:relative;
  width:100%;
  padding:0px;
  //background:red;
  margin-bottom:20px;
}

.detail-label{
  position:relative;
  width:100%;
  padding:5px;
  text-align:left;
  background:#eee;
}

.detail-chart{
  position:relative;
  width:100%;
  padding:0px;
  border:1px solid #eee;
}


.detail-table{
  position:relative;
  width:100%;
  padding:0px;
}

.detail-label-table{
  width:100%;
  padding-left:10px;
}

.detail-label-table .product-title{
  height:40px;
  font-size:14px;
  font-weight:600;
  color:#000;
  text-align:left;
}

.detail-label-table .title{
  height:20px;
  font-size:12px;
  color:#515151;
  text-align:left;
  padding-left:20px;
  border-left:1px solid #bbb;
}

.detail-label-table .title:first-child{
  padding-left:0px;
  border-left:0px solid #bbb;
}

.detail-label-table .value{
  height:30px;
  font-size:12px;
  font-weight:600;
  color:#000;
  text-align:left;
  padding-left:20px;
  border-left:1px solid #bbb;
}

.detail-label-table .value:first-child{
  padding-left:0px;
  border-left:0px solid #bbb;
  font-size:14px;
  color:red;
}

.detail-label-table .data{
  height:40px;
  padding-left:20px;
  line-height:40px;
  font-size:12px;
  color:#515151;
  text-align:left;
  background-image:url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 12px;
}

.list-tab-chart-ul {
  display:flex;
  justify-content:flex-start;
  margin-top: 5px;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding:2px 2px 2px 10px;
}

.list-tab-chart-li {
  float: left;
  margin: 0px 0px 0px 0px;
  height: 30px;
  width: 60px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
  border:1px solid #598118;
}

.list-tab-chart-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.li-chart-active{
  color: #ffffff;
  background: #598118;
}

.detail-label .product-location{
  position:relative;
  height:30px;
  width:50%;
  padding:5px;
  font-size:12px;
  font-weight:600;
  line-height:30px;
  text-align:left;
  color:green;
}

.detail-label .product-remark{
  position:relative;
  height:30px;
  width:50%;
  padding:5px;
  font-size:12px;
  line-height:30px;
  text-align:left;
  color:#515151;
}

.detail-price-table{
  width:100%;
}

.detail-price-table{
  width:100%;
}

.detail-price-table td{
  padding:10px;
  text-align:center;
  font-size:12px;
  border-bottom:1px solid #eee;
  border-right:1px solid #eee;
}

.detail-price-table tr:first-child  td{
  color:#bbb;
}

.detail-price-table tr td:first-child{
  color:#bbb;
  border-left:1px solid #eee;
}

</style>



// WEBPACK FOOTER //
// src/components/page/Sghq01DetailA.vue